import { environment } from 'environments/environment';
export { environment };
import * as Parse from 'parse';
export { Parse };

export const parseConfig = environment.PARSE;
